module.exports = __webpack_public_path__ + "static/img/安徽五一学堂1.fd74af6f.png";